import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,_vm._b({attrs:{"label":_vm.$t('Commission Percentage'),"type":"number","outlined":"","suffix":"%","hide-details":"auto"},model:{value:(_vm.commissionPercentage),callback:function ($$v) {_vm.commissionPercentage=_vm._n($$v)},expression:"commissionPercentage"}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }